import actions from '../../../../redux/actions/ui/dataImport/strategies/batchStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function BatchStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

BatchStrategy.title = actions.title
const option = {
  value: 'add_to_batch',
  display: 'Add Orders To Batch',
  category: 'orders',
  Component: BatchStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
BatchStrategy.option = option
